import { Check } from "lucide-react";
import { Reveal, SectionHead, Em } from "@/components/Reveal";

const items = [
  "She knows there is more inside her.",
  "She knows she wasn’t born to live by someone else’s definition of success.",
  "She wants wealth without sacrificing her life.",
  "She wants love without abandoning herself.",
  "She wants motherhood without disappearing.",
  "She wants ambition without living permanently exhausted.",
  "She wants pleasure without guilt.",
  "She wants to create what is inside her.",
  "She wants her life to actually look and feel like hers.",
];

export const ForYouSection = () => (
  <section data-testid="for-you-section" className="border-y border-white/10 bg-coal">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:py-28">
      <SectionHead eyebrow="THIS IS FOR YOU IF…">
        THIS IS FOR THE WOMAN
        <br />
        WHO ALREADY <Em>KNOWS.</Em>
      </SectionHead>

      <div className="grid gap-3 sm:grid-cols-2" data-testid="for-you-list">
        {items.map((t, i) => (
          <Reveal key={t} delay={Math.min(i * 0.04, 0.3)}>
            <div className="flex h-full items-start gap-4 border border-white/10 bg-card p-5 transition-colors duration-300 hover:border-lime/50">
              <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-lime">
                <Check className="h-3.5 w-3.5 text-ink" strokeWidth={3} />
              </span>
              <p className="text-sm font-semibold leading-relaxed text-cream/85">{t}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-16 text-center">
        <p className="text-xl font-extrabold leading-tight tracking-tight text-cream/70 sm:text-2xl">
          SHE ISN’T LOOKING FOR SOMEONE TO SAVE HER.
        </p>
        <p className="mt-3 font-serif text-3xl italic leading-tight text-lime sm:text-5xl">
          SHE’S READY TO CHOOSE.
        </p>
      </Reveal>
    </div>
  </section>
);
